import { render, staticRenderFns } from "./Reset_Password.vue?vue&type=template&id=7187491c&scoped=true&"
import script from "./Reset_Password.vue?vue&type=script&lang=js&"
export * from "./Reset_Password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7187491c",
  null
  
)

export default component.exports